import Separator from "@/app/components/lib/Separator";
import { JSX } from "react";

interface props {
  title: JSX.Element | string;
  children: React.ReactNode;
  endLabel?: {
    label: JSX.Element | string;
    onClick: () => void;
  };
}

const BoxWithTitle: React.FC<props> = ({ title, children, endLabel }) => {
  return (
    <div className="box-with-title">
      <Separator startLabel={title} endLabel={endLabel} />
      {children}
    </div>
  );
};

export default BoxWithTitle;
